import React from 'react';
import { Button } from './ui/button';
import { ShieldQuestion } from 'lucide-react';

interface QuizWelcomeProps {
  onClick: (event: any) => void;
}

const QuizWelcome = (props: QuizWelcomeProps) => {
  return (
    <div className="mx-auto flex max-w-5xl flex-col items-center px-8 pt-4 text-center sm:px-0 sm:pt-0">
      <ShieldQuestion className="mx-auto mb-4 h-12 w-12 sm:mb-8 sm:h-20 sm:w-20" />
      <h1 className="mb-4 text-2xl font-bold sm:mb-8 sm:text-3xl">
        Test your git knowledge
      </h1>
      <h2 className="mb-4 text-balance sm:text-lg">With 10 questions</h2>
      <Button onClick={props.onClick}>Start Quiz</Button>
    </div>
  );
};

export default QuizWelcome;
